/** Supported Language codes (ISO 639-1 codes) */
export var LanguageCode;
(function (LanguageCode) {
    LanguageCode["UNDEFINED_LANGUAGE_CODE"] = "UNDEFINED_LANGUAGE_CODE";
    LanguageCode["aa"] = "aa";
    LanguageCode["ab"] = "ab";
    LanguageCode["ae"] = "ae";
    LanguageCode["af"] = "af";
    LanguageCode["ak"] = "ak";
    LanguageCode["am"] = "am";
    LanguageCode["an"] = "an";
    LanguageCode["ar"] = "ar";
    LanguageCode["as"] = "as";
    LanguageCode["av"] = "av";
    LanguageCode["ay"] = "ay";
    LanguageCode["az"] = "az";
    LanguageCode["ba"] = "ba";
    LanguageCode["be"] = "be";
    LanguageCode["bg"] = "bg";
    LanguageCode["bh"] = "bh";
    LanguageCode["bi"] = "bi";
    LanguageCode["bm"] = "bm";
    LanguageCode["bn"] = "bn";
    LanguageCode["bo"] = "bo";
    LanguageCode["br"] = "br";
    LanguageCode["bs"] = "bs";
    LanguageCode["ca"] = "ca";
    LanguageCode["ce"] = "ce";
    LanguageCode["ch"] = "ch";
    LanguageCode["co"] = "co";
    LanguageCode["cr"] = "cr";
    LanguageCode["cs"] = "cs";
    LanguageCode["cu"] = "cu";
    LanguageCode["cv"] = "cv";
    LanguageCode["cy"] = "cy";
    LanguageCode["da"] = "da";
    LanguageCode["de"] = "de";
    LanguageCode["dv"] = "dv";
    LanguageCode["dz"] = "dz";
    LanguageCode["ee"] = "ee";
    LanguageCode["el"] = "el";
    LanguageCode["en"] = "en";
    LanguageCode["eo"] = "eo";
    LanguageCode["es"] = "es";
    LanguageCode["et"] = "et";
    LanguageCode["eu"] = "eu";
    LanguageCode["fa"] = "fa";
    LanguageCode["ff"] = "ff";
    LanguageCode["fi"] = "fi";
    LanguageCode["fj"] = "fj";
    LanguageCode["fo"] = "fo";
    LanguageCode["fr"] = "fr";
    LanguageCode["fy"] = "fy";
    LanguageCode["ga"] = "ga";
    LanguageCode["gd"] = "gd";
    LanguageCode["gl"] = "gl";
    LanguageCode["gn"] = "gn";
    LanguageCode["gu"] = "gu";
    LanguageCode["gv"] = "gv";
    LanguageCode["ha"] = "ha";
    LanguageCode["he"] = "he";
    LanguageCode["hi"] = "hi";
    LanguageCode["ho"] = "ho";
    LanguageCode["hr"] = "hr";
    LanguageCode["ht"] = "ht";
    LanguageCode["hu"] = "hu";
    LanguageCode["hy"] = "hy";
    LanguageCode["hz"] = "hz";
    LanguageCode["ia"] = "ia";
    LanguageCode["id"] = "id";
    LanguageCode["ie"] = "ie";
    LanguageCode["ig"] = "ig";
    LanguageCode["ii"] = "ii";
    LanguageCode["ik"] = "ik";
    LanguageCode["io"] = "io";
    LanguageCode["is"] = "is";
    LanguageCode["it"] = "it";
    LanguageCode["iu"] = "iu";
    LanguageCode["ja"] = "ja";
    LanguageCode["jv"] = "jv";
    LanguageCode["ka"] = "ka";
    LanguageCode["ki"] = "ki";
    LanguageCode["kk"] = "kk";
    LanguageCode["kl"] = "kl";
    LanguageCode["km"] = "km";
    LanguageCode["kn"] = "kn";
    LanguageCode["ko"] = "ko";
    LanguageCode["kr"] = "kr";
    LanguageCode["ks"] = "ks";
    LanguageCode["ku"] = "ku";
    LanguageCode["kw"] = "kw";
    LanguageCode["ky"] = "ky";
    LanguageCode["la"] = "la";
    LanguageCode["lb"] = "lb";
    LanguageCode["lg"] = "lg";
    LanguageCode["li"] = "li";
    LanguageCode["ln"] = "ln";
    LanguageCode["lo"] = "lo";
    LanguageCode["lt"] = "lt";
    LanguageCode["lu"] = "lu";
    LanguageCode["lv"] = "lv";
    LanguageCode["mg"] = "mg";
    LanguageCode["mh"] = "mh";
    LanguageCode["mi"] = "mi";
    LanguageCode["mk"] = "mk";
    LanguageCode["ml"] = "ml";
    LanguageCode["mn"] = "mn";
    LanguageCode["mr"] = "mr";
    LanguageCode["ms"] = "ms";
    LanguageCode["mt"] = "mt";
    LanguageCode["my"] = "my";
    LanguageCode["na"] = "na";
    LanguageCode["nb"] = "nb";
    LanguageCode["nd"] = "nd";
    LanguageCode["ne"] = "ne";
    LanguageCode["ng"] = "ng";
    LanguageCode["nl"] = "nl";
    LanguageCode["nn"] = "nn";
    LanguageCode["no"] = "no";
    LanguageCode["nr"] = "nr";
    LanguageCode["nv"] = "nv";
    LanguageCode["ny"] = "ny";
    LanguageCode["oc"] = "oc";
    LanguageCode["oj"] = "oj";
    LanguageCode["om"] = "om";
    LanguageCode["or"] = "or";
    LanguageCode["os"] = "os";
    LanguageCode["pa"] = "pa";
    LanguageCode["pi"] = "pi";
    LanguageCode["pl"] = "pl";
    LanguageCode["ps"] = "ps";
    LanguageCode["pt"] = "pt";
    LanguageCode["qu"] = "qu";
    LanguageCode["rm"] = "rm";
    LanguageCode["rn"] = "rn";
    LanguageCode["ro"] = "ro";
    LanguageCode["ru"] = "ru";
    LanguageCode["rw"] = "rw";
    LanguageCode["sa"] = "sa";
    LanguageCode["sc"] = "sc";
    LanguageCode["sd"] = "sd";
    LanguageCode["se"] = "se";
    LanguageCode["sg"] = "sg";
    LanguageCode["si"] = "si";
    LanguageCode["sk"] = "sk";
    LanguageCode["sl"] = "sl";
    LanguageCode["sm"] = "sm";
    LanguageCode["sn"] = "sn";
    LanguageCode["so"] = "so";
    LanguageCode["sq"] = "sq";
    LanguageCode["sr"] = "sr";
    LanguageCode["ss"] = "ss";
    LanguageCode["st"] = "st";
    LanguageCode["su"] = "su";
    LanguageCode["sv"] = "sv";
    LanguageCode["sw"] = "sw";
    LanguageCode["ta"] = "ta";
    LanguageCode["te"] = "te";
    LanguageCode["tg"] = "tg";
    LanguageCode["th"] = "th";
    LanguageCode["ti"] = "ti";
    LanguageCode["tk"] = "tk";
    LanguageCode["tl"] = "tl";
    LanguageCode["tn"] = "tn";
    LanguageCode["to"] = "to";
    LanguageCode["tr"] = "tr";
    LanguageCode["ts"] = "ts";
    LanguageCode["tt"] = "tt";
    LanguageCode["tw"] = "tw";
    LanguageCode["ty"] = "ty";
    LanguageCode["ug"] = "ug";
    LanguageCode["uk"] = "uk";
    LanguageCode["ur"] = "ur";
    LanguageCode["uz"] = "uz";
    LanguageCode["ve"] = "ve";
    LanguageCode["vi"] = "vi";
    LanguageCode["vo"] = "vo";
    LanguageCode["wa"] = "wa";
    LanguageCode["wo"] = "wo";
    LanguageCode["xh"] = "xh";
    LanguageCode["yi"] = "yi";
    LanguageCode["yo"] = "yo";
    LanguageCode["za"] = "za";
    LanguageCode["zh"] = "zh";
    LanguageCode["zu"] = "zu";
})(LanguageCode || (LanguageCode = {}));
/** List of suuported region codes (ISO 3166-1 alpha-2) */
export var RegionCode;
(function (RegionCode) {
    RegionCode["UNDEFINED_REGION_CODE"] = "UNDEFINED_REGION_CODE";
    RegionCode["ad"] = "ad";
    RegionCode["ae"] = "ae";
    RegionCode["af"] = "af";
    RegionCode["ag"] = "ag";
    RegionCode["ai"] = "ai";
    RegionCode["al"] = "al";
    RegionCode["am"] = "am";
    RegionCode["ao"] = "ao";
    RegionCode["ar"] = "ar";
    RegionCode["as"] = "as";
    RegionCode["at"] = "at";
    RegionCode["au"] = "au";
    RegionCode["aw"] = "aw";
    RegionCode["ax"] = "ax";
    RegionCode["az"] = "az";
    RegionCode["ba"] = "ba";
    RegionCode["bb"] = "bb";
    RegionCode["bd"] = "bd";
    RegionCode["be"] = "be";
    RegionCode["bf"] = "bf";
    RegionCode["bg"] = "bg";
    RegionCode["bh"] = "bh";
    RegionCode["bi"] = "bi";
    RegionCode["bj"] = "bj";
    RegionCode["bl"] = "bl";
    RegionCode["bm"] = "bm";
    RegionCode["bn"] = "bn";
    RegionCode["bo"] = "bo";
    RegionCode["bq"] = "bq";
    RegionCode["br"] = "br";
    RegionCode["bs"] = "bs";
    RegionCode["bt"] = "bt";
    RegionCode["bw"] = "bw";
    RegionCode["by"] = "by";
    RegionCode["bz"] = "bz";
    RegionCode["ca"] = "ca";
    RegionCode["cd"] = "cd";
    RegionCode["cf"] = "cf";
    RegionCode["cg"] = "cg";
    RegionCode["ch"] = "ch";
    RegionCode["ci"] = "ci";
    RegionCode["cl"] = "cl";
    RegionCode["cm"] = "cm";
    RegionCode["cn"] = "cn";
    RegionCode["co"] = "co";
    RegionCode["cr"] = "cr";
    RegionCode["cu"] = "cu";
    RegionCode["cv"] = "cv";
    RegionCode["cw"] = "cw";
    RegionCode["cy"] = "cy";
    RegionCode["cz"] = "cz";
    RegionCode["de"] = "de";
    RegionCode["dj"] = "dj";
    RegionCode["dk"] = "dk";
    RegionCode["dm"] = "dm";
    RegionCode["do"] = "do";
    RegionCode["dz"] = "dz";
    RegionCode["ec"] = "ec";
    RegionCode["ee"] = "ee";
    RegionCode["eg"] = "eg";
    RegionCode["eo"] = "eo";
    RegionCode["er"] = "er";
    RegionCode["es"] = "es";
    RegionCode["et"] = "et";
    RegionCode["fi"] = "fi";
    RegionCode["fj"] = "fj";
    RegionCode["fk"] = "fk";
    RegionCode["fm"] = "fm";
    RegionCode["fo"] = "fo";
    RegionCode["fr"] = "fr";
    RegionCode["ga"] = "ga";
    RegionCode["gb"] = "gb";
    RegionCode["gd"] = "gd";
    RegionCode["ge"] = "ge";
    RegionCode["gg"] = "gg";
    RegionCode["gh"] = "gh";
    RegionCode["gi"] = "gi";
    RegionCode["gl"] = "gl";
    RegionCode["gm"] = "gm";
    RegionCode["gn"] = "gn";
    RegionCode["gp"] = "gp";
    RegionCode["gq"] = "gq";
    RegionCode["gr"] = "gr";
    RegionCode["gs"] = "gs";
    RegionCode["gt"] = "gt";
    RegionCode["gu"] = "gu";
    RegionCode["gw"] = "gw";
    RegionCode["gy"] = "gy";
    RegionCode["hk"] = "hk";
    RegionCode["hn"] = "hn";
    RegionCode["hr"] = "hr";
    RegionCode["ht"] = "ht";
    RegionCode["hu"] = "hu";
    RegionCode["ia"] = "ia";
    RegionCode["id"] = "id";
    RegionCode["ie"] = "ie";
    RegionCode["il"] = "il";
    RegionCode["im"] = "im";
    RegionCode["in"] = "in";
    RegionCode["io"] = "io";
    RegionCode["iq"] = "iq";
    RegionCode["ir"] = "ir";
    RegionCode["is"] = "is";
    RegionCode["it"] = "it";
    RegionCode["je"] = "je";
    RegionCode["jm"] = "jm";
    RegionCode["jo"] = "jo";
    RegionCode["jp"] = "jp";
    RegionCode["ke"] = "ke";
    RegionCode["kg"] = "kg";
    RegionCode["kh"] = "kh";
    RegionCode["ki"] = "ki";
    RegionCode["km"] = "km";
    RegionCode["kn"] = "kn";
    RegionCode["kp"] = "kp";
    RegionCode["kr"] = "kr";
    RegionCode["kw"] = "kw";
    RegionCode["ky"] = "ky";
    RegionCode["kz"] = "kz";
    RegionCode["la"] = "la";
    RegionCode["lb"] = "lb";
    RegionCode["lc"] = "lc";
    RegionCode["li"] = "li";
    RegionCode["lk"] = "lk";
    RegionCode["lr"] = "lr";
    RegionCode["ls"] = "ls";
    RegionCode["lt"] = "lt";
    RegionCode["lu"] = "lu";
    RegionCode["lv"] = "lv";
    RegionCode["ly"] = "ly";
    RegionCode["ma"] = "ma";
    RegionCode["mc"] = "mc";
    RegionCode["md"] = "md";
    RegionCode["me"] = "me";
    RegionCode["mf"] = "mf";
    RegionCode["mg"] = "mg";
    RegionCode["mh"] = "mh";
    RegionCode["mk"] = "mk";
    RegionCode["ml"] = "ml";
    RegionCode["mm"] = "mm";
    RegionCode["mn"] = "mn";
    RegionCode["mo"] = "mo";
    RegionCode["mp"] = "mp";
    RegionCode["mq"] = "mq";
    RegionCode["mr"] = "mr";
    RegionCode["ms"] = "ms";
    RegionCode["mt"] = "mt";
    RegionCode["mv"] = "mv";
    RegionCode["mw"] = "mw";
    RegionCode["mx"] = "mx";
    RegionCode["my"] = "my";
    RegionCode["mz"] = "mz";
    RegionCode["na"] = "na";
    RegionCode["nc"] = "nc";
    RegionCode["ne"] = "ne";
    RegionCode["nf"] = "nf";
    RegionCode["ng"] = "ng";
    RegionCode["ni"] = "ni";
    RegionCode["nl"] = "nl";
    RegionCode["no"] = "no";
    RegionCode["np"] = "np";
    RegionCode["nr"] = "nr";
    RegionCode["nu"] = "nu";
    RegionCode["nz"] = "nz";
    RegionCode["om"] = "om";
    RegionCode["pa"] = "pa";
    RegionCode["pe"] = "pe";
    RegionCode["pf"] = "pf";
    RegionCode["pg"] = "pg";
    RegionCode["ph"] = "ph";
    RegionCode["pk"] = "pk";
    RegionCode["pl"] = "pl";
    RegionCode["pm"] = "pm";
    RegionCode["pn"] = "pn";
    RegionCode["pr"] = "pr";
    RegionCode["ps"] = "ps";
    RegionCode["pt"] = "pt";
    RegionCode["pw"] = "pw";
    RegionCode["py"] = "py";
    RegionCode["qa"] = "qa";
    RegionCode["re"] = "re";
    RegionCode["ro"] = "ro";
    RegionCode["rs"] = "rs";
    RegionCode["ru"] = "ru";
    RegionCode["rw"] = "rw";
    RegionCode["sa"] = "sa";
    RegionCode["sb"] = "sb";
    RegionCode["sc"] = "sc";
    RegionCode["sd"] = "sd";
    RegionCode["se"] = "se";
    RegionCode["sg"] = "sg";
    RegionCode["sh"] = "sh";
    RegionCode["si"] = "si";
    RegionCode["sj"] = "sj";
    RegionCode["sk"] = "sk";
    RegionCode["sl"] = "sl";
    RegionCode["sm"] = "sm";
    RegionCode["sn"] = "sn";
    RegionCode["so"] = "so";
    RegionCode["sr"] = "sr";
    RegionCode["ss"] = "ss";
    RegionCode["st"] = "st";
    RegionCode["sv"] = "sv";
    RegionCode["sx"] = "sx";
    RegionCode["sy"] = "sy";
    RegionCode["sz"] = "sz";
    RegionCode["tc"] = "tc";
    RegionCode["td"] = "td";
    RegionCode["tf"] = "tf";
    RegionCode["tg"] = "tg";
    RegionCode["th"] = "th";
    RegionCode["tj"] = "tj";
    RegionCode["tk"] = "tk";
    RegionCode["tl"] = "tl";
    RegionCode["tm"] = "tm";
    RegionCode["tn"] = "tn";
    RegionCode["to"] = "to";
    RegionCode["tr"] = "tr";
    RegionCode["tt"] = "tt";
    RegionCode["tv"] = "tv";
    RegionCode["tw"] = "tw";
    RegionCode["tz"] = "tz";
    RegionCode["ua"] = "ua";
    RegionCode["ug"] = "ug";
    RegionCode["us"] = "us";
    RegionCode["uy"] = "uy";
    RegionCode["uz"] = "uz";
    RegionCode["va"] = "va";
    RegionCode["vc"] = "vc";
    RegionCode["ve"] = "ve";
    RegionCode["vg"] = "vg";
    RegionCode["vi"] = "vi";
    RegionCode["vn"] = "vn";
    RegionCode["vu"] = "vu";
    RegionCode["wf"] = "wf";
    RegionCode["ws"] = "ws";
    RegionCode["ye"] = "ye";
    RegionCode["yt"] = "yt";
    RegionCode["za"] = "za";
    RegionCode["zm"] = "zm";
    RegionCode["zw"] = "zw";
    RegionCode["um"] = "um";
    RegionCode["gf"] = "gf";
})(RegionCode || (RegionCode = {}));
/** All valid script codes */
export var Script;
(function (Script) {
    Script["UNDEFINED_SCRIPT"] = "UNDEFINED_SCRIPT";
    Script["Adlm"] = "Adlm";
    Script["Afak"] = "Afak";
    Script["Aghb"] = "Aghb";
    Script["Ahom"] = "Ahom";
    Script["Arab"] = "Arab";
    Script["Aran"] = "Aran";
    Script["Armi"] = "Armi";
    Script["Armn"] = "Armn";
    Script["Avst"] = "Avst";
    Script["Bali"] = "Bali";
    Script["Bamu"] = "Bamu";
    Script["Bass"] = "Bass";
    Script["Batk"] = "Batk";
    Script["Beng"] = "Beng";
    Script["Bhks"] = "Bhks";
    Script["Blis"] = "Blis";
    Script["Bopo"] = "Bopo";
    Script["Brah"] = "Brah";
    Script["Brai"] = "Brai";
    Script["Bugi"] = "Bugi";
    Script["Buhd"] = "Buhd";
    Script["Cakm"] = "Cakm";
    Script["Cans"] = "Cans";
    Script["Cari"] = "Cari";
    Script["Cham"] = "Cham";
    Script["Cher"] = "Cher";
    Script["Cirt"] = "Cirt";
    Script["Copt"] = "Copt";
    Script["Cpmn"] = "Cpmn";
    Script["Cprt"] = "Cprt";
    Script["Cyrl"] = "Cyrl";
    Script["Cyrs"] = "Cyrs";
    Script["Deva"] = "Deva";
    Script["Dogr"] = "Dogr";
    Script["Dsrt"] = "Dsrt";
    Script["Dupl"] = "Dupl";
    Script["Egyd"] = "Egyd";
    Script["Egyh"] = "Egyh";
    Script["Egyp"] = "Egyp";
    Script["Elba"] = "Elba";
    Script["Elym"] = "Elym";
    Script["Ethi"] = "Ethi";
    Script["Geok"] = "Geok";
    Script["Geor"] = "Geor";
    Script["Glag"] = "Glag";
    Script["Gong"] = "Gong";
    Script["Gonm"] = "Gonm";
    Script["Goth"] = "Goth";
    Script["Gran"] = "Gran";
    Script["Grek"] = "Grek";
    Script["Gujr"] = "Gujr";
    Script["Guru"] = "Guru";
    Script["Hanb"] = "Hanb";
    Script["Hang"] = "Hang";
    Script["Hani"] = "Hani";
    Script["Hano"] = "Hano";
    Script["Hans"] = "Hans";
    Script["Hant"] = "Hant";
    Script["Hatr"] = "Hatr";
    Script["Hebr"] = "Hebr";
    Script["Hira"] = "Hira";
    Script["Hluw"] = "Hluw";
    Script["Hmng"] = "Hmng";
    Script["Hmnp"] = "Hmnp";
    Script["Hrkt"] = "Hrkt";
    Script["Hung"] = "Hung";
    Script["Inds"] = "Inds";
    Script["Ital"] = "Ital";
    Script["Jamo"] = "Jamo";
    Script["Java"] = "Java";
    Script["Jpan"] = "Jpan";
    Script["Jurc"] = "Jurc";
    Script["Kali"] = "Kali";
    Script["Kana"] = "Kana";
    Script["Khar"] = "Khar";
    Script["Khmr"] = "Khmr";
    Script["Khoj"] = "Khoj";
    Script["Kitl"] = "Kitl";
    Script["Kits"] = "Kits";
    Script["Knda"] = "Knda";
    Script["Kore"] = "Kore";
    Script["Kpel"] = "Kpel";
    Script["Kthi"] = "Kthi";
    Script["Lana"] = "Lana";
    Script["Laoo"] = "Laoo";
    Script["Latf"] = "Latf";
    Script["Latg"] = "Latg";
    Script["Latn"] = "Latn";
    Script["Leke"] = "Leke";
    Script["Lepc"] = "Lepc";
    Script["Limb"] = "Limb";
    Script["Lina"] = "Lina";
    Script["Linb"] = "Linb";
    Script["Lisu"] = "Lisu";
    Script["Loma"] = "Loma";
    Script["Lyci"] = "Lyci";
    Script["Lydi"] = "Lydi";
    Script["Mahj"] = "Mahj";
    Script["Maka"] = "Maka";
    Script["Mand"] = "Mand";
    Script["Mani"] = "Mani";
    Script["Marc"] = "Marc";
    Script["Maya"] = "Maya";
    Script["Medf"] = "Medf";
    Script["Mend"] = "Mend";
    Script["Merc"] = "Merc";
    Script["Mero"] = "Mero";
    Script["Mlym"] = "Mlym";
    Script["Modi"] = "Modi";
    Script["Mong"] = "Mong";
    Script["Moon"] = "Moon";
    Script["Mroo"] = "Mroo";
    Script["Mtei"] = "Mtei";
    Script["Mult"] = "Mult";
    Script["Mymr"] = "Mymr";
    Script["Nand"] = "Nand";
    Script["Narb"] = "Narb";
    Script["Nbat"] = "Nbat";
    Script["Newa"] = "Newa";
    Script["Nkdb"] = "Nkdb";
    Script["Nkgb"] = "Nkgb";
    Script["Nkoo"] = "Nkoo";
    Script["Nshu"] = "Nshu";
    Script["Ogam"] = "Ogam";
    Script["Olck"] = "Olck";
    Script["Orkh"] = "Orkh";
    Script["Orya"] = "Orya";
    Script["Osge"] = "Osge";
    Script["Osma"] = "Osma";
    Script["Palm"] = "Palm";
    Script["Pauc"] = "Pauc";
    Script["Perm"] = "Perm";
    Script["Phag"] = "Phag";
    Script["Phli"] = "Phli";
    Script["Phlp"] = "Phlp";
    Script["Phlv"] = "Phlv";
    Script["Phnx"] = "Phnx";
    Script["Plrd"] = "Plrd";
    Script["Piqd"] = "Piqd";
    Script["Prti"] = "Prti";
    Script["Qaaa"] = "Qaaa";
    Script["Qabx"] = "Qabx";
    Script["Rjng"] = "Rjng";
    Script["Rohg"] = "Rohg";
    Script["Roro"] = "Roro";
    Script["Runr"] = "Runr";
    Script["Samr"] = "Samr";
    Script["Sara"] = "Sara";
    Script["Sarb"] = "Sarb";
    Script["Saur"] = "Saur";
    Script["Sgnw"] = "Sgnw";
    Script["Shaw"] = "Shaw";
    Script["Shrd"] = "Shrd";
    Script["Shui"] = "Shui";
    Script["Sidd"] = "Sidd";
    Script["Sind"] = "Sind";
    Script["Sinh"] = "Sinh";
    Script["Sogd"] = "Sogd";
    Script["Sogo"] = "Sogo";
    Script["Sora"] = "Sora";
    Script["Soyo"] = "Soyo";
    Script["Sund"] = "Sund";
    Script["Sylo"] = "Sylo";
    Script["Syrc"] = "Syrc";
    Script["Syre"] = "Syre";
    Script["Syrj"] = "Syrj";
    Script["Syrn"] = "Syrn";
    Script["Tagb"] = "Tagb";
    Script["Takr"] = "Takr";
    Script["Tale"] = "Tale";
    Script["Talu"] = "Talu";
    Script["Taml"] = "Taml";
    Script["Tang"] = "Tang";
    Script["Tavt"] = "Tavt";
    Script["Telu"] = "Telu";
    Script["Teng"] = "Teng";
    Script["Tfng"] = "Tfng";
    Script["Tglg"] = "Tglg";
    Script["Thaa"] = "Thaa";
    Script["Thai"] = "Thai";
    Script["Tibt"] = "Tibt";
    Script["Tirh"] = "Tirh";
    Script["Ugar"] = "Ugar";
    Script["Vaii"] = "Vaii";
    Script["Visp"] = "Visp";
    Script["Wara"] = "Wara";
    Script["Wcho"] = "Wcho";
    Script["Wole"] = "Wole";
    Script["Xpeo"] = "Xpeo";
    Script["Xsux"] = "Xsux";
    Script["Yiii"] = "Yiii";
    Script["Zanb"] = "Zanb";
    Script["Zinh"] = "Zinh";
    Script["Zmth"] = "Zmth";
    Script["Zsye"] = "Zsye";
    Script["Zsym"] = "Zsym";
    Script["Zxxx"] = "Zxxx";
    Script["Zyyy"] = "Zyyy";
    Script["Zzzz"] = "Zzzz";
})(Script || (Script = {}));
export var LocaleStatus;
(function (LocaleStatus) {
    /** Value not specified */
    LocaleStatus["UNDEFINED_STATUS"] = "UNDEFINED_STATUS";
    /** Locale was added to site but was not activated */
    LocaleStatus["INACTIVE"] = "INACTIVE";
    /** Locale was added to site and activated */
    LocaleStatus["ACTIVE"] = "ACTIVE";
    /** Default locale (always active) */
    LocaleStatus["DEFAULT"] = "DEFAULT";
})(LocaleStatus || (LocaleStatus = {}));
export var Flag;
(function (Flag) {
    Flag["UNDEFINED_FLAG_CODE"] = "UNDEFINED_FLAG_CODE";
    Flag["AFG"] = "AFG";
    Flag["AGO"] = "AGO";
    Flag["AIA"] = "AIA";
    Flag["ALA"] = "ALA";
    Flag["ALB"] = "ALB";
    Flag["AND"] = "AND";
    Flag["ARE"] = "ARE";
    Flag["ARG"] = "ARG";
    Flag["ARM"] = "ARM";
    Flag["ASM"] = "ASM";
    Flag["ATF"] = "ATF";
    Flag["ATG"] = "ATG";
    Flag["AUS"] = "AUS";
    Flag["AUT"] = "AUT";
    Flag["AZE"] = "AZE";
    Flag["BDI"] = "BDI";
    Flag["BEL"] = "BEL";
    Flag["BEN"] = "BEN";
    Flag["BES"] = "BES";
    Flag["BFA"] = "BFA";
    Flag["BGD"] = "BGD";
    Flag["BGR"] = "BGR";
    Flag["BHR"] = "BHR";
    Flag["BHS"] = "BHS";
    Flag["BIH"] = "BIH";
    Flag["BLM"] = "BLM";
    Flag["BLR"] = "BLR";
    Flag["BLZ"] = "BLZ";
    Flag["BMU"] = "BMU";
    Flag["BOL"] = "BOL";
    Flag["BRA"] = "BRA";
    Flag["BRB"] = "BRB";
    Flag["BRN"] = "BRN";
    Flag["BRT"] = "BRT";
    Flag["BTN"] = "BTN";
    Flag["BWA"] = "BWA";
    Flag["CAF"] = "CAF";
    Flag["CAN"] = "CAN";
    Flag["CAT"] = "CAT";
    Flag["CHE"] = "CHE";
    Flag["CHL"] = "CHL";
    Flag["CHN"] = "CHN";
    Flag["CIV"] = "CIV";
    Flag["CMR"] = "CMR";
    Flag["COD"] = "COD";
    Flag["COG"] = "COG";
    Flag["COL"] = "COL";
    Flag["COM"] = "COM";
    Flag["COR"] = "COR";
    Flag["CPV"] = "CPV";
    Flag["CRI"] = "CRI";
    Flag["CUB"] = "CUB";
    Flag["CUW"] = "CUW";
    Flag["CYM"] = "CYM";
    Flag["CZE"] = "CZE";
    Flag["DEU"] = "DEU";
    Flag["DJI"] = "DJI";
    Flag["DMA"] = "DMA";
    Flag["DNK"] = "DNK";
    Flag["DOM"] = "DOM";
    Flag["DZA"] = "DZA";
    Flag["ECU"] = "ECU";
    Flag["EGY"] = "EGY";
    Flag["ERI"] = "ERI";
    Flag["ESP"] = "ESP";
    Flag["EST"] = "EST";
    Flag["ETH"] = "ETH";
    Flag["EUR"] = "EUR";
    Flag["EUS"] = "EUS";
    Flag["FIN"] = "FIN";
    Flag["FJI"] = "FJI";
    Flag["FLK"] = "FLK";
    Flag["FRA"] = "FRA";
    Flag["FRO"] = "FRO";
    Flag["FSM"] = "FSM";
    Flag["GAB"] = "GAB";
    Flag["GBR"] = "GBR";
    Flag["GEO"] = "GEO";
    Flag["GGY"] = "GGY";
    Flag["GHA"] = "GHA";
    Flag["GIB"] = "GIB";
    Flag["GIN"] = "GIN";
    Flag["GLG"] = "GLG";
    Flag["GLO"] = "GLO";
    Flag["GLP"] = "GLP";
    Flag["GMB"] = "GMB";
    Flag["GNB"] = "GNB";
    Flag["GNQ"] = "GNQ";
    Flag["GRC"] = "GRC";
    Flag["GRD"] = "GRD";
    Flag["GRL"] = "GRL";
    Flag["GTM"] = "GTM";
    Flag["GUM"] = "GUM";
    Flag["GUY"] = "GUY";
    Flag["HKG"] = "HKG";
    Flag["HND"] = "HND";
    Flag["HRV"] = "HRV";
    Flag["HTI"] = "HTI";
    Flag["HUN"] = "HUN";
    Flag["IDN"] = "IDN";
    Flag["IMN"] = "IMN";
    Flag["IND"] = "IND";
    Flag["IOT"] = "IOT";
    Flag["IRL"] = "IRL";
    Flag["IRN"] = "IRN";
    Flag["IRQ"] = "IRQ";
    Flag["ISL"] = "ISL";
    Flag["ISR"] = "ISR";
    Flag["ITA"] = "ITA";
    Flag["JAM"] = "JAM";
    Flag["JEY"] = "JEY";
    Flag["JOR"] = "JOR";
    Flag["JPN"] = "JPN";
    Flag["KAZ"] = "KAZ";
    Flag["KEN"] = "KEN";
    Flag["KGZ"] = "KGZ";
    Flag["KHM"] = "KHM";
    Flag["KIR"] = "KIR";
    Flag["KNA"] = "KNA";
    Flag["KOR"] = "KOR";
    Flag["KUR"] = "KUR";
    Flag["KWT"] = "KWT";
    Flag["LAO"] = "LAO";
    Flag["LBN"] = "LBN";
    Flag["LBR"] = "LBR";
    Flag["LBY"] = "LBY";
    Flag["LCA"] = "LCA";
    Flag["LIE"] = "LIE";
    Flag["LKA"] = "LKA";
    Flag["LSO"] = "LSO";
    Flag["LTU"] = "LTU";
    Flag["LUX"] = "LUX";
    Flag["LVA"] = "LVA";
    Flag["MAC"] = "MAC";
    Flag["MAF"] = "MAF";
    Flag["MAR"] = "MAR";
    Flag["MCO"] = "MCO";
    Flag["MDA"] = "MDA";
    Flag["MDG"] = "MDG";
    Flag["MDV"] = "MDV";
    Flag["MEX"] = "MEX";
    Flag["MHL"] = "MHL";
    Flag["MKD"] = "MKD";
    Flag["MLI"] = "MLI";
    Flag["MLT"] = "MLT";
    Flag["MMR"] = "MMR";
    Flag["MNE"] = "MNE";
    Flag["MNG"] = "MNG";
    Flag["MNP"] = "MNP";
    Flag["MOZ"] = "MOZ";
    Flag["MRT"] = "MRT";
    Flag["MSR"] = "MSR";
    Flag["MTQ"] = "MTQ";
    Flag["MWI"] = "MWI";
    Flag["MYS"] = "MYS";
    Flag["MYT"] = "MYT";
    Flag["NAM"] = "NAM";
    Flag["NCL"] = "NCL";
    Flag["NER"] = "NER";
    Flag["NFK"] = "NFK";
    Flag["NGA"] = "NGA";
    Flag["NIC"] = "NIC";
    Flag["NIU"] = "NIU";
    Flag["NLD"] = "NLD";
    Flag["NOR"] = "NOR";
    Flag["NPL"] = "NPL";
    Flag["NRU"] = "NRU";
    Flag["NZL"] = "NZL";
    Flag["OMN"] = "OMN";
    Flag["PAK"] = "PAK";
    Flag["PAN"] = "PAN";
    Flag["PCN"] = "PCN";
    Flag["PER"] = "PER";
    Flag["PHL"] = "PHL";
    Flag["PLW"] = "PLW";
    Flag["PNG"] = "PNG";
    Flag["POL"] = "POL";
    Flag["PRI"] = "PRI";
    Flag["PRK"] = "PRK";
    Flag["PRT"] = "PRT";
    Flag["PRY"] = "PRY";
    Flag["PSE"] = "PSE";
    Flag["PYF"] = "PYF";
    Flag["QAT"] = "QAT";
    Flag["REU"] = "REU";
    Flag["ROU"] = "ROU";
    Flag["RUS"] = "RUS";
    Flag["RWA"] = "RWA";
    Flag["SAU"] = "SAU";
    Flag["SDN"] = "SDN";
    Flag["SEN"] = "SEN";
    Flag["SGP"] = "SGP";
    Flag["SGS"] = "SGS";
    Flag["SHN"] = "SHN";
    Flag["SJM"] = "SJM";
    Flag["SLB"] = "SLB";
    Flag["SLE"] = "SLE";
    Flag["SLV"] = "SLV";
    Flag["SMR"] = "SMR";
    Flag["SOM"] = "SOM";
    Flag["SPM"] = "SPM";
    Flag["SRB"] = "SRB";
    Flag["SSD"] = "SSD";
    Flag["STP"] = "STP";
    Flag["SUR"] = "SUR";
    Flag["SVK"] = "SVK";
    Flag["SVN"] = "SVN";
    Flag["SWE"] = "SWE";
    Flag["SWZ"] = "SWZ";
    Flag["SXM"] = "SXM";
    Flag["SYC"] = "SYC";
    Flag["SYR"] = "SYR";
    Flag["TCA"] = "TCA";
    Flag["TCD"] = "TCD";
    Flag["TGO"] = "TGO";
    Flag["THA"] = "THA";
    Flag["TJK"] = "TJK";
    Flag["TKL"] = "TKL";
    Flag["TKM"] = "TKM";
    Flag["TLS"] = "TLS";
    Flag["TON"] = "TON";
    Flag["TTO"] = "TTO";
    Flag["TUN"] = "TUN";
    Flag["TUR"] = "TUR";
    Flag["TUV"] = "TUV";
    Flag["TWN"] = "TWN";
    Flag["TZA"] = "TZA";
    Flag["UGA"] = "UGA";
    Flag["UKR"] = "UKR";
    Flag["URY"] = "URY";
    Flag["USA"] = "USA";
    Flag["UZB"] = "UZB";
    Flag["VAT"] = "VAT";
    Flag["VCT"] = "VCT";
    Flag["VEN"] = "VEN";
    Flag["VGB"] = "VGB";
    Flag["VIR"] = "VIR";
    Flag["VLC"] = "VLC";
    Flag["VNM"] = "VNM";
    Flag["VUT"] = "VUT";
    Flag["WLF"] = "WLF";
    Flag["WLS"] = "WLS";
    Flag["YEM"] = "YEM";
    Flag["ZAF"] = "ZAF";
    Flag["ZMB"] = "ZMB";
    Flag["ZWE"] = "ZWE";
})(Flag || (Flag = {}));
/** A locale's auto translate mode determines if new content added in primary language will be auto translated for this Locale */
export var AutoTranslate;
(function (AutoTranslate) {
    AutoTranslate["OFF"] = "OFF";
    AutoTranslate["ON"] = "ON";
})(AutoTranslate || (AutoTranslate = {}));
export var WebhookIdentityType;
(function (WebhookIdentityType) {
    WebhookIdentityType["UNKNOWN"] = "UNKNOWN";
    WebhookIdentityType["ANONYMOUS_VISITOR"] = "ANONYMOUS_VISITOR";
    WebhookIdentityType["MEMBER"] = "MEMBER";
    WebhookIdentityType["WIX_USER"] = "WIX_USER";
    WebhookIdentityType["APP"] = "APP";
})(WebhookIdentityType || (WebhookIdentityType = {}));
//# sourceMappingURL=types.impl.js.map